import { render, staticRenderFns } from "./upgradeplan.vue?vue&type=template&id=4c57f760&"
import script from "./upgradeplan.vue?vue&type=script&lang=js&"
export * from "./upgradeplan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports